import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { conversationalTags } from "./constants";
import type { ConversationalTagsResult } from "./types";
import { isConversationalTagsResult } from "./validators";

/**
 * GET handler for the "/:app_group_id/conversational/tags" endpoint.
 */
export const getConversationalTags = reactQueryFetcherAdapter(
  conversationalTags,
  (signal: AbortSignal, appGroupId: string): Promise<ConversationalTagsResult> => {
    return fetch(`/${appGroupId}/conversational/tags`, "GET", {}, { signal });
  },
  isConversationalTagsResult
);
